import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import ScrollMemory from 'react-router-scroll-memory';
import Stopper, { THEMES } from '@bit/gerenciatd.unifiedcomponents.stopper';
import { QUEUE_NAMES } from '@bit/gerenciatd.utils.context';
import { actions as contextActions } from './Reducers/context';
import CreateRouter from './createRouter';
import ErrorBoundary from './ErrorBoundary';

class Core extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextData: null,
    };
  }

  componentDidMount = () => {
    const { projectId } = this.props;

    window.nookInfoExchange.registerAsObserver(
      QUEUE_NAMES.GLOBAL,
      `MainAppControllerListener-${projectId}`,
      (data) => {
        window.nookInfoExchange.cleanObserver(
          QUEUE_NAMES.GLOBAL,
          `MainAppControllerListener-${projectId}`,
        );
        this.setState({ contextData: data });
        this.props.setContextData(data);
      },
    );
  };

  render() {
    const {
      projectId,
      history,
      urlLibrary,
      modulesLibrary,
      defaultErrorScreen,
      inPageError,
    } = this.props;
    const { contextData } = this.state;

    if (!contextData) {
      // fake o algo timeout de error...
      return null;
    }

    return (
      <Fragment>
        <div id="mainContent" className="mainContent xux">
          <ErrorBoundary
            history={history}
            projectId={projectId}
            defaultErrorScreen={defaultErrorScreen}
            contextData={contextData}
          >
            {inPageError && (
              <Stopper
                theme={THEMES.EMPTY}
                content={inPageError.errorType}
                contentProps={inPageError.errorInfo}
                projectId={projectId}
              />
            )}
            {!inPageError
              && CreateRouter(urlLibrary, modulesLibrary, contextData, projectId)}
          </ErrorBoundary>
          <ScrollMemory />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  inPageError: state.errorCatcher.inPageError,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setContextData: data => dispatch(contextActions.setContextData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Core);
